export default `float s = 1.;
    float t = 999.;
    for(int i = 0; i < 12; i++){
      float k =  1.3/clamp(dot(p,p),0.1,1.);
      p *= k; s *= k;
      p=abs(p)-vec3(6.2,2.,1.7);
      p=mod(p-1.,2.)-1.;
      t = min(t, length(p)/s);
    }
    return t;
  }`